const hostOverrides = new Map<string, string | undefined>()

function readHostOverride(service: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const meta = document.querySelector<HTMLMetaElement>(`meta[name="${service}-host"]`)?.content.trim()
  const attr = document.documentElement.getAttribute(`data-${service}-host`)?.trim()
  return meta || attr || undefined
}

function serviceHostOverride(service: string): string | undefined {
  if (!hostOverrides.has(service)) hostOverrides.set(service, readHostOverride(service))
  return hostOverrides.get(service)
}

function resetOverrides(): void {
  hostOverrides.clear()
}

function serviceHost(service: string, fallbackHost: string): string {
  return serviceHostOverride(service) ?? fallbackHost
}

function serviceOrigin(service: string, fallbackHost: string): string {
  return `https://${serviceHost(service, fallbackHost)}`
}

function serviceWsOrigin(service: string, fallbackHost: string): string {
  return `wss://${serviceHost(service, fallbackHost)}`
}

export { resetOverrides, serviceHost, serviceHostOverride, serviceOrigin, serviceWsOrigin }
